import Column from '@components/Column';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    header?: ReactNode;
    children?: ReactNode;
    footer?: ReactNode;
    noFooterBorder?: boolean;
    footerPosition?: 'FIXED' | 'RELATIVE';
 }

function CtaLayout({
    children, header, footer, noFooterBorder, footerPosition,
}:Props) {
    const isRelative = footerPosition === 'RELATIVE';
    return (
        <Column fullWidth fullHeight aria-label='cta'>
            {header}
            <Contents fullWidth
                id='cta-contents'
                data-scroll-restoration={true} >
                {children}
                {(isRelative && footer) && (
                    <Footer noBorder={noFooterBorder}>
                        {footer}
                    </Footer>
                )}
            </Contents>
            {(!isRelative && footer) && (
                <Footer noBorder={noFooterBorder}>
                    {footer}
                </Footer>
            )}
        </Column>
    );
}

const Contents = styled(Column)`
    flex: 1;
    overflow-y: auto;
`;

const Footer = styled.div<{
    noBorder?: boolean;
}>`
    &:has(*) {
        background-color: ${colors.white};
        border-top: ${(props) => (props.noBorder ? 'none' : '1px solid var(--color-gray2)')};
        padding: var(--spacing-4) var(--spacing-5) calc(var(--spacing-3) + var(--safe-area-bottom));
        width: 100%;
        z-index: 2;
    }`;

export default CtaLayout;
